import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element)
  }

  open() {
    this.modal.show()
  }

  submitEnd(event) {
    if (!event.detail.success) return

    const form = event.target.closest("form")
    if (!form) return

    if (form.dataset.modalClose === "true") {
      this.modal.hide()
    }
  }

  clear() {
    const frame = this.element.querySelector("#turbo_modal")
    if (frame) frame.innerHTML = ""
  }
}